const openLink = (link) => {
    if (link.startsWith('http://') || link.startsWith('https://')) {
      window.open(link, '_blank');
    } else {
      window.open(link, '_blank');
    }
  };

  export default openLink;